import type { IconSvgObject } from './types';

const ChevronsDownIcon: IconSvgObject = [
  ["path", { d: "M17 6.00004C17 6.00004 13.3176 11 12 11C10.6824 11 7 6 7 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 13C17 13 13.3176 18 12 18C10.6824 18 7 13 7 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronsDownIcon;
